// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"798":"a546ff5c","878":"eb8b7b75"}[chunkId] + ".js";
};